import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { UserService } from "./../services/user.service";
import { environment } from 'src/environments/environment.dev';


@Injectable({
  providedIn: 'root'
})
export class DistributionApiService {

  //   apiBase: String = "https://sdapi.songdew.com/apis";
  // imageApiBase: String = "https://sdapi.songdew.com/";
  // apiBaseRegister: String = "https://sdapi.songdew.com/apis/v2";
  urlRevenuePdf = "https://sdapi.songdew.com"; // Revenue Report Base Url
  apiBase: String = "https://orbit.songdew.com/apis";
  imageApiBase: String = "https://orbit.songdew.com/";
  apiBaseRegister: String = "https://orbit.songdew.com/apis/v2";
  // urlRevenuePdf = "https://orbit.songdew.com"; // Revenue Report PBase Url  
  artistPageSongBaseUrl = "https://songdewnetwork.com"; // SongBase URl  in Artist Listing

  // apiBase: String = "https://orbit.songdew.com/apis";
  // imageApiBase: String = "https://orbit.songdew.com/";
  // apiBaseRegister: String = "https://orbit.songdew.com/apis/v2";
  // urlRevenuePdf = "https://orbit.songdew.com"; // Revenue Report PBase Url  


  // apiBase: String = "http://164.52.200.19:8000/apis";
  // imageApiBase: String = "http://164.52.200.19:8000/";
  // apiBaseRegister: String = "http://164.52.200.19:8000/apis/v2";
  // urlRevenuePdf = "http://164.52.200.19:8000"; // Revenue Report Base Url
  // artistPageSongBaseUrl = "https://songdewnetwork.com"; // SongBase URl  in Artist Listing


  // apiBase: String = 'https://sdapi.songdew.com/apis';
  // localAPITest="https://69f42e1e17ef.ngrok.io";

  oppApiBase: String = "https://sdapi.songdew.com/apis";

  angularBase = "https://songdew.com";
  // angularBase = 'https://new.songdew.com';
  oppCountryBase = "https://sdapi.songdew.com/apis/v2";

  //oppCountryBase = "http://164.52.200.19:8000/apis/v2";

  private clientId: string = "bdbe4301b9f74d6bad6886584766ee23";
  private clientSecret: string = "079a9caa45594dae8d87598f0bb6c2a3";


  private Aclient_id: string = "2T7SB4ZCZ6.songdew.com";
  private Aclient_secret: string = "bdbe4301b9f74d6bad6886584766ee23";
  private appleDeveloperToken: string = environment.apple_developer_token
  demo: string;


  constructor(private http: HttpClient, private user: UserService) { }



  public getDisributedSongDetails(slug): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);

    let params = new HttpParams();
    params = params.append("song_slug", slug);
    return this.http.get(this.apiBase + "/distribute/v3/get_distributed_song_details/",
      {
        params: params,
        headers: headers,

      })
  }
  public getAgreementDetails(): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.get(this.apiBase + "/distribute/terms_greement/",
      {
        headers: headers,

      })
  }

  public getDisributedAlbumDetails(slug): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);

    let params = new HttpParams();
    params = params.append("album_slug", slug);
    return this.http.get(this.apiBase + "/distribute/v3/get_distributed_album_details/",
      {
        params: params,
        headers: headers,

      })
  }



  checkBankAccount(
    form_step,
    email,
    id,
    type
  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v2/upload_distribute_song/",
      {
        form_step: form_step,
        email: email,
        id: id,
        type: type



      },
      {
        headers: headers,

      })


  }

  checkAgreementStatusApi(

    formNum,
    songTitle,
    artistName,
    artist_email


  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v2/upload_distribute_song/",
      {
        form_step: formNum,
        song_title: songTitle,
        song_artist: artistName,
        artist_email: artist_email


      },
      {
        headers: headers,

      })

  }



  public addDistrubutRelaseForm(
    form_step,
    primary_artist,
    feature_artist,
    secondary_artists,
    title,
    version,
    song_id,
    // fb_id,
    // ig_id,
    // youtube_id,
    stage_name,
    otherCredits,
    releaseValue

  ): any {

    const headers = new HttpHeaders().set("Authorization", this.user.token);

    return this.http.post(
      this.apiBase + "/distribute/v2/upload_distribute_song/",
      {
        form_step: form_step,
        primary_artist: primary_artist,
        feature_artist: feature_artist,
        secondary_artists: secondary_artists,
        title: title,
        version: version,
        song_id: song_id,
        otherCredits: otherCredits,
        // fb_id: fb_id,
        // ig_id: ig_id,
        // youtube_id: youtube_id,
        stage_name: stage_name,
        release_type: releaseValue,

      },
      {
        headers: headers,
      }
    );





  }

  public getSocialMediaId(): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.get(
      this.apiBase + "/distribute/get_profile_elements/",
      {
        headers: headers,
      }
    )

  }

  public trackdetailsUpload(
    form_step,
    uploadedfile,
    originalfile,
    song_id,
    language,
    genre,
    production_year,
    lyrics,
    arranger,
    producer,
    author,
    remixer,
    composer,
    for_opp,
    presave,
    record_label,
    subgenre,
    duration,
    explicit,

    crbtStart,
    crbtEnd,
    ytbeContentId,
    declaration,
    coverPermission,
    coverPerDoc,
    sampleData?: { hasSamples: boolean | null, sampleSources: string, sampleOthersName: string, sampleLicenseDoc: string }
  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);

    return this.http.post(this.apiBase + "/distribute/v2/upload_distribute_song/",
      {
        form_step: form_step,
        uploadedfile: uploadedfile,
        originalfile: originalfile,
        song_id: song_id,
        language: language,
        genre: genre,
        production_year: production_year,
        lyrics: lyrics,
        arranger: arranger,
        producer: producer,
        authors: author,
        remixer: remixer,
        composers: composer,
        for_opp: for_opp,
        presave: presave,
        record_label: record_label,
        subgenre: subgenre,
        duration: duration,
        explicit: explicit,

        crbt_start: crbtStart,
        crbt_end: crbtEnd,
        ytbe_content_id: ytbeContentId ? 1 : 0,
        declaration: declaration,
        cover_permission: coverPermission ? 1 : 0,
        cover_per_doc: coverPerDoc,
        ...(sampleData ? {
          has_samples: sampleData.hasSamples,
          sample_sources: sampleData.sampleSources,
          sample_others_name: sampleData.sampleOthersName,
          sample_license_doc: sampleData.sampleLicenseDoc
        } : {})
      },
      {
        headers: headers,
      }
    );
  }


  public distributAlbumImage(
    form_step,
    song_id,
    image
  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v2/upload_distribute_song/",
      {
        form_step: form_step,
        song_id: song_id,
        image: image



      },
      {
        headers: headers,

      })

  }


  public distributeReleseDate(
    form_step,
    song_id,
    release_date,
    other_release_date,
    upc,
    isrc,
    previousDistributor,
    prevOtherDistributor,
    hungamaDetails,
    gaanaDetails,


  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v2/upload_distribute_song/",
      {
        form_step: form_step,
        song_id: song_id,
        release_date: release_date,
        other_release_date: other_release_date,
        upc: upc,
        isrc: isrc,
        previousDistributor: previousDistributor,
        prevOtherDistributor: prevOtherDistributor,
        hungamaDetails: hungamaDetails,
        gaanaDetails: gaanaDetails,

      },
      {
        headers: headers,

      })
  }


  public distributionAgreementFrm(
    form_step,
    song_id,
    mob_num,
    countryCode,
    ag_name,
    ag_email,
    ag_bank_name,
    ag_account_no,
    ag_holder_name,
    ag_ifsc,
    countryName,
    // ag_address,
  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);

    return this.http.post(this.apiBase + "/distribute/v2/upload_distribute_song/",
      {
        form_step: form_step,
        song_id: song_id,
        ag_name: ag_name,
        ag_email: ag_email,
        ag_bank_name: ag_bank_name,
        ag_account_no: ag_account_no,
        ag_holder_name: ag_holder_name,
        ag_ifsc: ag_ifsc,
        mob_num: mob_num,
        countryCode: countryCode,
        countryName: countryName



        // ag_address: ag_address
      },
      {
        headers: headers,

      })

  }


  public distributionOtpSend(
    countryCode,
    mobile_number,
    user_id,
    agreement_id,
    whatsapp = false

  ): any {


    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/distribution_agreement/send_otp/",
      {
        mobile_number: mobile_number,
        countryCode: countryCode,
        user_id: user_id,
        agreement_id: agreement_id,
        whatsapp: whatsapp ? 1 : 0


      },
      {
        headers: headers,

      })


  }


  public distributionOtpVerify(
    slug,
    is_album,
    agreement_id,
    sign,
    place,
    ip,
    otp,
    type = 'mobile',
    term_agreement,
  ): any {

    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v3/distribution_agreement/verify_otp/",
      {
        slug: slug,
        is_album: is_album ? 1 : 0,
        agreement_id: agreement_id,
        sign: sign,
        place: place,
        ip: ip,
        otp: otp,
        single: 1,
        type: type,
        term_agreement: term_agreement,
      },
      {
        headers: headers,

      })


  }


  public offlineAgreementsVerify(
    agreement_id,
    sign,
    place,
    ip,
    otp,
    type = 'mobile'
  ): any {

    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v3/offline_agreement/verify_otp/",
      {
        agreement_id: agreement_id,
        sign: sign,
        place: place,
        ip: ip,
        otp: otp,
        single: 1,
        type: type
      },
      {
        headers: headers,

      })


  }

  /************************Music distribution for Album's Ep ************************************** */

  public albumEptrackdetailsUpload(

    form_step,
    album_id,
    id,
    uploadedfile,
    originalfile,
    title,
    primary_artist,
    feature_artist,
    secondary_artists,
    language,
    genre,
    production_year,
    lyrics,
    explicit,
    arranger,
    producer,
    author,
    remixer,
    composer,
    for_opp,
    presave,
    record_label,
    subgenre,
    duration,

    crbtStart,
    crbtEnd,
    ytbeContentId,
    declaration,
    coverPermission,
    coverPerDoc,
    sampleData?: { hasSamples: boolean | null, sampleSources: string, sampleOthersName: string, sampleLicenseDoc: string }
  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    const samplePayload = sampleData ? {
      has_samples: sampleData.hasSamples,
      sample_sources: sampleData.sampleSources,
      sample_others_name: sampleData.sampleOthersName,
      sample_license_doc: sampleData.sampleLicenseDoc
    } : {};
    if (id == "" || id == undefined || id == null) {
      return this.http.post(this.apiBase + "/distribute/v3/upload_music_to_distribution_album/",
        {
          form_step: form_step,
          albumid: album_id,
          song_id: id,
          uploadedfile: uploadedfile,
          originalfile: originalfile,
          title: title,
          primary_artist: primary_artist,
          feature_artist: feature_artist,
          secondary_artists: secondary_artists,
          language: [language],
          genre: [genre],
          production_year: production_year,
          lyrics: lyrics,
          explicit: explicit,
          arranger: arranger,
          producer: producer,
          author: author,
          remixer: remixer,
          composer: composer,
          for_opp: for_opp,
          presave: presave,
          record_label: record_label,
          subgenre: subgenre,
          duration: duration,

          crbt_start: crbtStart,
          crbt_end: crbtEnd,
          ytbe_content_id: ytbeContentId ? 1 : 0,
          declaration: declaration,
          cover_permission: coverPermission ? 1 : 0,
          cover_per_doc: coverPerDoc,
          ...samplePayload
        },
        {
          headers: headers,
        }
      );
    } else {
      return this.http.put(this.apiBase + "/distribute/v3/upload_music_to_distribution_album/",
        {
          albumid: album_id,
          songid: id,
          title: title,
          primary_artist: primary_artist,
          feature_artist: feature_artist,
          secondary_artists: secondary_artists,
          language: [language],
          genre: [genre],
          production_year: production_year,
          lyrics: lyrics,
          explicit: explicit,
          arranger: arranger,
          producer: producer,
          author: author,
          remixer: remixer,
          composer: composer,
          for_opp: for_opp,
          presave: presave,
          record_label: record_label,
          subgenre: subgenre,
          duration: duration,

          crbt_start: crbtStart,
          crbt_end: crbtEnd,
          ytbe_content_id: ytbeContentId ? 1 : 0,
          declaration: declaration,
          cover_permission: coverPermission ? 1 : 0,
          cover_per_doc: coverPerDoc,
          ...samplePayload

        },
        {
          headers: headers,
        }
      );
    }

  }


  public albumEpdistributeReleseDate(
    form_step,
    album_id,
    release_date,
    other_release_date,
    upc,
    isrc,
    previousDistributor,
    prevOtherDistributor,
    hungamaDetails,
    gaanaDetails,



  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v3/upload_distribute_album/",
      {
        form_step: form_step,
        album_id: album_id,
        release_date: release_date,
        other_release_date: other_release_date,
        upc: upc,
        isrc: isrc,
        previousDistributor: previousDistributor,
        prevOtherDistributor: prevOtherDistributor,
        hungamaDetails: hungamaDetails,
        gaanaDetails: gaanaDetails,


      },
      {
        headers: headers,

      })
  }


  public albumRelaseFormDistribution(
    form_step,
    album_id,
    primary_artist,
    feature_artist,
    secondary_artists,
    title,
    version,
    fb_id,
    ig_id,
    youtube_id,
    stage_name,
    otherCredits,
    releaseValue



  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    if (album_id == undefined) {
      return this.http.post(
        this.apiBase + "/distribute/v3/upload_distribute_album/",
        {
          form_step: form_step,
          albumid: album_id,
          primary_artist: primary_artist,
          feature_artist: feature_artist,
          secondary_artists: secondary_artists,
          title: title,
          version: version,
          fb_id,
          ig_id,
          youtube_id,
          stage_name,
          otherCredits: otherCredits,
          release_type: releaseValue

        },
        {
          headers: headers,
        }
      );
    } else {
      return this.http.put(
        this.apiBase + "/distribute/v3/upload_distribute_album/",
        {
          form_step: form_step,
          albumid: album_id,
          primary_artist: primary_artist,
          feature_artist: feature_artist,
          secondary_artists: secondary_artists,
          title: title,
          version: version,
          otherCredits: otherCredits
        },
        {
          headers: headers,
        }
      );
    }



  }

  public albumEpDistributAlbumImage(
    form_step,
    album_id,
    image
  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v3/upload_distribute_album/",
      {
        form_step: form_step,
        album_id: album_id,
        image: image
      },
      {
        headers: headers,

      })

  }



  public albumEpDistributionAgreementFrm(
    form_step,
    album_id,
    mob_num,
    countryCode,
    ag_name,
    ag_email,
    ag_bank_name,
    ag_account_no,
    ag_holder_name,
    ag_ifsc,
    countryName
    // ag_address,
  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);

    return this.http.post(this.apiBase + "/distribute/save_agreement_for_distribution_album/",
      {
        form_step: form_step,
        album_id: album_id,
        ag_name: ag_name,
        ag_email: ag_email,
        ag_bank_name: ag_bank_name,
        ag_account_no: ag_account_no,
        ag_holder_name: ag_holder_name,
        ag_ifsc: ag_ifsc,
        mob_num: mob_num,
        countryCode: countryCode,
        countryName: countryName


        // ag_address: ag_address
      },
      {
        headers: headers,

      })

  }

  public albumEpDistributionOtpSend(
    countryCode,
    mobile_number,
    user_id,
    agreement_id

  ): any {


    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/distribution_agreement/send_otp/",
      {
        countryCode: countryCode,
        mobile_number: mobile_number,
        user_id: user_id,
        agreement_id: agreement_id

      },
      {
        headers: headers,

      })


  }



  public albumEpDistributionOtpVerify(
    slug,
    is_album,
    agreement_id,
    sign,
    place,
    ip,
    otp,
    type = 'mobile',
    term_agreement
  ): any {

    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v3/distribution_agreement/verify_otp/",
      {
        slug: slug,
        is_album: is_album ? 1 : 0,
        agreement_id: agreement_id,
        sign: sign,
        place: place,
        ip: ip,
        otp: otp,
        single: 0,
        form_step: 6,
        type: type,
        term_agreement: term_agreement,
      },
      {
        headers: headers,

      })


  }


  public albumEpMultiTrackUpload(
    albumId,
    uploadedfile,
    title,
    primary_artist,
    feature_artist,
    secondary_artists,
    language,
    genre,
    production_year,
    lyrics,
    arranger,
    producer,
    author,
    remixer,
    composer,
    for_opp,
    presave,
    record_label,
    subgenre
  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/v3/upload_music_to_distribution_album/",
      {
        album_id: albumId,
        uploadedfile: uploadedfile,
        title: title,
        primary_artist: primary_artist,
        feature_artist: feature_artist,
        secondary_artists: secondary_artists,
        language: language,
        genre: genre,
        production_year: production_year,
        lyrics: lyrics,
        arranger: arranger,
        producer: producer,
        author: author,
        remixer: remixer,
        composer: composer,
        for_opp: for_opp,
        presave: presave,
        record_label: record_label,
        subgenre: subgenre
      },
      {
        headers: headers,

      })

  }



  public getLanguages(available = false, type = "", genre = []): any {
    let params = new HttpParams();
    params = params.append("type", type);
    genre.forEach((genreName) => {
      if (genreName == "all_genres") {
        genreName = "";
      }
      params = params.append("genre", genreName);
    });

    if (available) {
      return this.http.get(this.apiBase + "/language-available/", {
        params: params,
      });
    } else {
      return this.http.get(this.apiBase + "/language/", {
        params: params,
      });
    }
  }



  public getGenres(available = false, type = "", lang = ""): any {
    let params = new HttpParams();
    params = params.append("type", type);
    params = params.append("lng", lang);

    if (available) {
      return this.http.get(this.apiBase + "/genre-available/", {
        params: params,
      });
    } else {
      return this.http.get(this.apiBase + "/genre/", { params: params });
    }
  }



  public getSubgenrs(genre: any): any {
    let params = new HttpParams();

    return this.http.get(this.apiBase + "/subgenre/?genre=" + genre, {
      params: params,
    });


  }

  public getPrimaryArtistSpotifyId(): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.get(this.apiBase + "/distribute/get_external_profiles/", {

      headers: headers,
    });
  }
  public authspotifyV2(): any {

    const headers = new HttpHeaders()
      .set('Authorization', 'Basic ' + btoa(this.clientId + ":" + this.clientSecret))
      .set('Content-Type', 'application/x-www-form-urlencoded');
    let params: URLSearchParams = new URLSearchParams();
    params.set('grant_type', 'client_credentials');
    let body = params.toString();
    return this.http.post(
      "https://accounts.spotify.com/api/token", body,
      {
        headers: headers,
      }
    );

  }


  public authspotify(): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.get(this.apiBase + "/distribute/get_spotify/", {
      headers: headers,
    });

  }


  public spotigetArtist(id: string, authToken: string): any {

    const headers = new HttpHeaders().
      set('Authorization', 'Bearer ' + authToken);
    const artistUrl = 'https://api.spotify.com/v1/artists/' + id;
    return this.http.get(artistUrl, { headers: headers });

  }

  public uploadAlbumTrack(frmData): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);

    frmData.append("user_id", this.user.id);

    return this.http.post(this.apiBase + "/uploadsong/", frmData, {
      reportProgress: true,
      observe: "events",
      headers: headers,
    });
  }

  public deleteDistributionSong(slug, isAlbum): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    let params = new HttpParams();
    //   let   tslug="sdcsdcsdc-43942";
    params = params.append("song_slug", slug);
    params = params.append("isAlbum", isAlbum);


    return this.http.delete(this.apiBase + "/distribute/delete_song_distribution/", {
      params: params,
      headers: headers,
    });
  }


  public getDistributedList(slug, offset = 0, limit = 20, view = "", onlyReleased = ""): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    let params = new HttpParams();

    params = params.append("offset", offset.toString());
    params = params.append("limit", limit.toString());
    params = params.append("view", view);

    if (onlyReleased == 'released') {
      params = params.append("onlyReleased", "1");
    } else {
      params = params.append("onlyReleased", "0");
    }


    return this.http.get(this.apiBase + "/distribute/get_distribution/", {
      params: params,
      headers: headers,
    });
  }


  public getDistributedReleaseBySlug(slug: string, isAlbum: boolean): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    let params = new HttpParams();

    params = params.append("slug", slug);
    params = params.append("isalbum", isAlbum ? "1" : "0");

    return this.http.get(this.apiBase + "/distribute/get_distribution/", {
      params: params,
      headers: headers,
    });
  }





  public applecheck(): any {

    const headers = new HttpHeaders().
      set('Authorization', 'Bearer ' + this.appleDeveloperToken);
    const artistUrl = 'https://api.music.apple.com/v1/test';
    return this.http.get(artistUrl, { headers: headers });

  }



  public authapple(id, countryCode = 'us'): any {

    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this.appleDeveloperToken)
      .set('Content-Type', 'application/x-www-form-urlencoded');

    // console.log(countryCode)

    return this.http.get(
      "https://api.music.apple.com/v1/catalog/" + countryCode + "/artists/" + id,

      {
        // params: params,
        headers: headers,
      }
    );

  }


  public token(): any {

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded');


    let params = new HttpParams();

    params = params.append('client_id', this.Aclient_id);
    params = params.append('client_secret', this.Aclient_secret);
    params = params.append('grant_type', 'refresh_token');



    return this.http.post(
      "https://appleid.apple.com/auth/token",
      {
        params: params,
        headers: headers,
      }
    );

  }

  public exitPopupTracker(mobile, type, userId): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);

    return this.http.post(
      this.apiBase + "/distribute/lead_popup/",
      {
        "mobile": mobile,
        "user_id": userId,
        "type": type,
      },

      {
        headers: headers,
      }
    );
  }



  public clarificationForm(
    albumId,
    mid,
    uploadedfile,
    originalfile,
    duration,
    image,
    release_date,

  ): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + '/distribute/track_modifaction', {
      album_id: albumId,
      mid: mid,
      uploaded_file: uploadedfile,
      original_file: originalfile,
      duration: duration,
      image: image,
      release_date: release_date,
    },
      {
        headers: headers
      }
    )
  }

  public checkClarificationIssue(slug, isalbum): any {
    console.log("isalbum", isalbum)
    const headers = new HttpHeaders().set("Authorization", this.user.token);

    let params = new HttpParams();
    params = params.append("slug", slug);
    params = params.append("isalbum", isalbum);
    return this.http.get(this.apiBase + '/distribute/get_distribution/', {
      params: params,
      headers: headers,
    })

  }
  // Analytics call
  public getAnalyticsGraph(payload: any) {
    const headers = new HttpHeaders()
      .set('Authorization', this.user.token)
    return this.http.post(this.apiBase + '/analytics/get-analytics/',
      payload,
      { headers }
    );
  }

  public getAnalyticsStats(payload: any): any {
    const headers = new HttpHeaders()
      .set('Authorization', this.user.token)
    return this.http.post(this.apiBase + '/analytics/get-statistics/',
      payload,
      { headers });
  }
  public fetchArtistInfo(labelId: string = '') {
    const headers = new HttpHeaders()
      .set("Authorization", this.user.token);

    let params: any = {};
    if (labelId) {
      params.label_id = labelId;
    }

    return this.http.get(this.apiBase + '/analytics/get-live-media/', {
      headers: headers,
      params: params
    });
  }

  public getTopStores(payload: any): any {
    const headers = new HttpHeaders()
      .set('Authorization', this.user.token)
    return this.http.post(this.apiBase + '/analytics/get-top-stores/', payload, { headers });
  }
  public ocr(payload) {
    const headers = new HttpHeaders()
    return this.http.post('https://art.songdew.com/analyze-artwork', payload, { headers });
  }

  public termSendOtp(payload: any): any {

    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/term_send_otp/", payload, { headers: headers })
  }

  public termVerifyOtp(payload: any): any {

    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/distribute/term_verify_otp/", payload, { headers: headers })
  }
  public getLabelData() {
    return this.http.get(this.apiBase + "/label/artists/show/")
  }
  public deleteArtist(id) {
    return this.http.post(this.apiBase + "/label/artists/save/", id)
  }
  public createLabelArtist(data) {
    return this.http.post(this.apiBase + "/label/artists/save/", data)
  }

  public submitSpotifyVideo(formData: FormData): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/spotify_video/save/", formData, {
      headers: headers,
    });
  }

  // Fixing a single flagged field (video_link or thumbnail) on an existing submission, reached
  // from the release detail VIDEO RELEASE panel's "Action Required" row - distinct from
  // submitSpotifyVideo() above, which is the first-time full submission.
  public resubmitSpotifyVideo(formData: FormData): any {
    const headers = new HttpHeaders().set("Authorization", this.user.token);
    return this.http.post(this.apiBase + "/spotify_video/resubmit_video/", formData, {
      headers: headers,
    });
  }
}
